(function () {
  const SECTION_SELECTOR = '.it-the-key';
  const IMAGE_SELECTOR = '.the-key__image img';
  const TITLE_SELECTOR = '.the-key__title';
  const SCALE_RANGE = 0.45;
  const ROTATE_RANGE = 28;
  const TYPE_SPEED = 85;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function prepareTypedSpan(section) {
    const title = section.querySelector(TITLE_SELECTOR);

    if (!title) {
      return null;
    }

    const span = title.querySelector('span');

    if (!span) {
      return null;
    }

    const originalText = span.textContent || '';

    if (!originalText) {
      return null;
    }

    span.dataset.typedSource = originalText;
    span.innerHTML = '';

    return span;
  }

  function typeSpan(span) {
    if (!span || span.dataset.typedStarted === 'true') {
      return;
    }

    const source = span.dataset.typedSource || '';

    if (!source) {
      return;
    }

    span.dataset.typedStarted = 'true';

    let charIndex = 0;

    function tick() {
      charIndex += 1;
      span.textContent = source.slice(0, charIndex);

      if (charIndex < source.length) {
        window.setTimeout(tick, TYPE_SPEED);
        return;
      }
    }

    tick();
  }

  function updateSection(section) {
    const image = section.querySelector(IMAGE_SELECTOR);

    if (!image) {
      return;
    }

    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const start = viewportHeight;
    const end = -rect.height;
    const progress = clamp((start - rect.top) / (start - end), 0, 1);
    const scale = 1 + (SCALE_RANGE * progress);
    const rotate = ROTATE_RANGE - (ROTATE_RANGE * 2 * progress);

    image.style.transform = 'scale(' + scale.toFixed(3) + ') rotate(' + rotate.toFixed(2) + 'deg)';
  }

  function initSection(section) {
    const image = section.querySelector(IMAGE_SELECTOR);
    const typedSpan = prepareTypedSpan(section);

    if (!image) {
      return;
    }

    section.classList.add('is-reveal-ready');

    const fadeElements = section.querySelectorAll('.fade-up');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');

        if (typedSpan && entry.target.matches(TITLE_SELECTOR)) {
          window.setTimeout(() => {
            typeSpan(typedSpan);
          }, 220);
        }

        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -8% 0px',
    });

    fadeElements.forEach((element, index) => {
      element.style.transitionDelay = `${index * 120}ms`;
      observer.observe(element);
    });

    image.style.transformOrigin = 'center center';
    image.style.willChange = 'transform';

    let ticking = false;

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(() => {
        updateSection(section);
        ticking = false;
      });
    }

    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initSection(section);
    });
  });
})();
